module.exports = __webpack_public_path__ + "static/img/vip.8380695b.png";